import { render, staticRenderFns } from "./PurchaseOrderOrderReceipt.vue?vue&type=template&id=34178c1a&scoped=true"
import script from "./PurchaseOrderOrderReceipt.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOrderReceipt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOrderReceipt.vue?vue&type=style&index=0&id=34178c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34178c1a",
  null
  
)

export default component.exports